import { Dispatch, SetStateAction } from 'react';
import { IAsyncType, useAsync } from '.';
import { StockReceivingProcessResponse, amsV3Service } from '../../services';

export interface IStockReceivingProcess<T> extends IAsyncType<T> {
  stockReceivingProcess: T | null;
  setStockReceivingProcess: Dispatch<SetStateAction<T | null>>;
}

export interface UseStockReceivingProcessProps {
  deliveryRequestId?: number
}

const useStockReceivingProcess = (
  { deliveryRequestId }: UseStockReceivingProcessProps
): IStockReceivingProcess<StockReceivingProcessResponse | null> => {
  const { data, setData, loading, setLoading, parameters, setParameters } =
    useAsync<StockReceivingProcessResponse | null>(
      amsV3Service.getStockReceivingProcessByDeliveryRequestId,
      null,
      deliveryRequestId ? [deliveryRequestId] : null
    );

  return {
    stockReceivingProcess: data,
    setStockReceivingProcess: setData,
    loading,
    setLoading,
    parameters,
    setParameters
  };
};

export default useStockReceivingProcess;
